import React, { useEffect, useRef, useState } from 'react'
import Form from 'react-bootstrap/Form';
import { Col, Image, Modal, Row } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import { useForm } from "react-hook-form"
import { ErrorMessage } from '@hookform/error-message';
import './ConsentForm.css';
import { companyUniqueId, TelInput, isCompanyActive, showSearchExistingConsentBtn } from '../../components';
import { FormInputs, ICompany } from '@models';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { isLoading } from '../../components/Loader';
import DOMPurify from "dompurify";
import ConsentFormService from '../../services/ConsentFormService';
function makeLinksClickable(text: string) {
  if (!text) return "";

  // Match URLs (http, https, ftp, www, domain-only, IPs, etc.)
  const urlRegex =
    /\b((?:(?:https?|ftp):\/\/|www\.)[^\s<]+|(?:[a-z0-9-]+\.)+[a-z]{2,}(?:\/[^\s<]*)?|\b\d{1,3}(?:\.\d{1,3}){3}(?::\d+)?[^\s<]*)/gi;

  // Match email addresses
  const emailRegex =
    /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;

  // Replace URLs with anchor tags
  let formatted = text.replace(urlRegex, (url) => {
    let fullUrl = url;
    if (emailRegex.test(url)) {
      return `<a href="mailto:${url}">${url}</a>`; // Skip email addresses

    }
    // If starts with "www." or domain only, prepend "https://"
    if (!/^https?:\/\//i.test(url) && !/^ftp:\/\//i.test(url)) {
      fullUrl = `https://${url}`;
    }

    return `<a href="${fullUrl}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  // Replace emails with mailto links
  // formatted = formatted.replace(
  //   emailRegex,
  //   (email) => `<a href="mailto:${email}">${email}</a>`
  // );

  // Sanitize before injecting into DOM
  return DOMPurify.sanitize(formatted);
}
function ConsentForm() {
  const cert_url = useRef(null);
  const [hiddenFormValue, setHiddenFormValue] = useState<any>("");
  const [companyInfo, setCompanyInfo] = useState<ICompany>();
  const { uniqueId } = useParams();

  const [consentRequestId, setConsentRequestId] = useRecoilState(companyUniqueId);
  const [companyActive, setCompanyActive] = useRecoilState(isCompanyActive);
  const [errorMessage, setErrorMessage] = useState("");
  const setIsLoading = useSetRecoilState(isLoading);
  const showLoading = useRecoilValue(isLoading);
  const [serverCallInprogress, setServerCallInprogress] = useState(false);
  const [consentLanguageMessage, setConsentLanguageMessage] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showSearchBar, setShowSearchBar] = useRecoilState(showSearchExistingConsentBtn);
  const [hasPageExpired, setPageExpired] = useState(false);
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        console.log("User came back via browser back button (bfcache restore)!");
        // 👉 Handle your logic here
        setPageExpired(true);
      } else {
        console.log("Fresh page load, not from cache");
      }
    };

    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);



  const {
    register,
    control, trigger, reset,
    setError,
    setFocus,
    clearErrors,
    setValue, getValues,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>()

  const onSubmit = async (formData: FormInputs) => {
    if (serverCallInprogress) {
      return false;
    }

    let data = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      mobile_number: formData.mobileNumber,
      request_id: uniqueId,
      trusted_form_url: hiddenFormValue
    }

    console.log("Form Data : ", data);
    setServerCallInprogress(true);
    setErrorMessage("");

    ConsentFormService.submitForm(consentRequestId, data)
      .then((response: any) => {
        reset();
        setErrorMessage(response.data.message);
        setShowSuccessModal(true);
        console.log(response.data);
        setServerCallInprogress(false);
      })
      .catch((e: any) => {
        if (e.response) {
          console.log(e.response); // => the response payload 
          setErrorMessage(e.response.data.message);

          if (e.response.status === 401) {
            setCompanyActive(false);
          }
        }
        setServerCallInprogress(false);
      });
  }

  const getConsentRequestLink = () => {
    console.log("Link Identifier : ", uniqueId);
    setIsLoading(true);
    ConsentFormService.getInfo(uniqueId?.toString() ?? "")
      .then((response: any) => {
        setConsentLanguageMessage(response.data.info.consent_lang_msg);
        if (response.data.info.consent_language.company.status === "INACTIVE" || response.data.info.consent_language.company.paused_status === "PAUSED") {
          setCompanyActive(false);
        } else if (response.data.info.consent_language.company.status === "CANCELED") {
          sessionStorage.setItem("cameBack", "true");
          window.location.href = "https://callerconsent.com/";
        } else {
          setCompanyActive(true);
        }

        setCompanyInfo(response.data.info.consent_language.company);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      })
      .catch((e: any) => {
        if (e.response.data.company_info) {
          setCompanyInfo(e.response.data.company_info);
        }
        setPageExpired(true);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    console.log("unique id : " + uniqueId);
    setShowSearchBar(false);
    if (uniqueId && uniqueId !== "") {
      let newUniqueId = uniqueId;
      setConsentRequestId(newUniqueId);
    }
  }, [uniqueId]);

  useEffect(() => {
    if (consentRequestId && consentRequestId !== "") {
      getConsentRequestLink();
    }
  }, [consentRequestId])
  const handleError = (e: any) => {

  }
  const handleRequestError = (msg: string) => {
    setCompanyActive(true);
    setErrorMessage(msg);
    setShowErrorModal(true);
    setIsLoading(false);
  }
  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
    sessionStorage.setItem("cameBack", "true");
    window.location.href = "https://callerconsent.com/";
  }

  useEffect(() => {
    setTimeout(() => {
      let hiddenInput: any = document.getElementsByClassName("cert_class");
      console.log(hiddenInput, "hiddenInput");
      if (hiddenInput.length > 0) {
        setHiddenFormValue(hiddenInput[0].value);
      }
    }, 1000);
  }, [showLoading]);
  return (
    !showLoading ?
      <>
        {
          hasPageExpired ?
            <div className='container'>
              <div className='container mt-4'>
                {/* <div className='alert alert-danger' role="alert" >
                  <h5>Sorry, this link has expired.</h5>
                </div> */}
                {
                  companyInfo ? <div className='mainbg p-4 '>
                    <Row className='text-center'>
                      <Col className=' mb-4 '>
                        <Image
                          src={companyInfo?.logo}
                          height={50}
                          style={{ height: "50px !important;" }}
                          alt="logo"
                        />
                      </Col>
                    </Row>
                    <center>
                      <h5 className='text-danger'>Sorry, this link has expired.</h5>
                    </center>
                  </div> : <div className='mainbg p-4 '>
                    <center>
                      <h5 className='text-danger'>Sorry, this link has expired.</h5>
                    </center>
                  </div>
                }

              </div>
            </div>
            : <>
              <div className='container'>
                <div className='container mt-4'>
                  {
                    !companyActive ? <div className="alert alert-danger" role="alert" >
                      This account is currently inactive. Please reactivate or contact <a href="mailto:info@tcpatech.com">info@tcpatech.com</a>.</div>
                      : null
                  }

                  <form onSubmit={handleSubmit(onSubmit, handleError)}>
                    <input
                      type="hidden"
                      className="cert_class"
                      name="xxTrustedFormCertUrl"
                      value=""
                      ref={cert_url}
                    />
                    <div className='mainbg p-4 '>
                      <Row className='text-center'>
                        <Col className=' mb-4 '>
                          <Image
                            src={companyInfo?.logo}
                            height={50}
                            style={{ height: "50px !important;" }}
                            alt="logo"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <h4>Your Information : </h4>
                        </Col>
                      </Row>

                      <div className='row'>
                        <div className='col-lg-4 mb-3 '>
                          <Form.Label htmlFor="txtFirstName" className='mb-1'>First Name *</Form.Label>
                          <Form.Control
                            type="text"
                            id="txtFirstName"
                            placeholder='Enter First Name'
                            autoComplete="off"
                            {...register("firstName", { required: "Please enter first name." })}
                          />
                          <ErrorMessage name="firstName" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />
                        </div>
                        <div className='col-lg-4 mb-3'>
                          <Form.Label htmlFor="txtLastName" className='mb-1'>Last Name *</Form.Label>
                          <Form.Control
                            type="text"
                            aria-describedby="passwordHelpBlock"
                            placeholder='Enter Last Name'
                            autoComplete="off"
                            {...register("lastName", { required: "Please enter last name." })}
                          />
                          <ErrorMessage name="lastName" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />

                        </div>
                        <div className='col-lg-4 mb-3'>
                          <Form.Label htmlFor="txtMobileNumber" className='mb-1'>Mobile Phone *</Form.Label>
                          <div>
                            <TelInput useFormMethods={
                              {
                                register,
                                control,
                                trigger
                              }
                            } name="mobileNumber" required={true} schema={{
                              errorMessage: {
                                required: "Please enter phone number",
                                // validate: 'Please enter a valid phone number.'
                              }
                            }} ></TelInput>
                          </div>
                          <ErrorMessage name="mobileNumber" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />
                        </div>
                      </div>
                      {/* <Row className='text-center'>
                  <Col className=' mb-4 '>
                    <Image
                      src={companyInfo?.logo}
                      height={50}
                      style={{ height: "50px !important;" }}
                      alt="logo"
                    />
                  </Col>
                </Row>
                <Row className='text-center'>
                  <Col className=' mb-4 '>
                    <h2>Consent Request </h2>
                  </Col>
                </Row>
                <Row>
                  <Col className='mb-4'>
                    <h4>Your Information: </h4>
                  </Col>
                </Row>
                <Row className=' justify-content-center'>
                  <Col lg={6}>
                    <Row>
                      <Col className='text-center mb-4 d-flex align-items-center gap-3'>
                        <Form.Label htmlFor="txtFirstName" className='mb-1 text-nowrap col-lg-3'>First Name *</Form.Label>
                        <Form.Control
                          type="text"
                          id="txtFirstName"
                          placeholder='Enter First Name'
                          autoComplete="off"
                          {...register("firstName", { required: "Please enter first name." })}
                        />
                        <input
                          type="hidden"
                          className="cert_class"
                          name="xxTrustedFormCertUrl"
                          value=""
                          ref={cert_url}
                        />
                        <ErrorMessage name="firstName" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />
                      </Col>
                    </Row>
                    <Row>
                      <Col className='text-center mb-4  d-flex align-items-center gap-3'>
                        <Form.Label htmlFor="txtLastName" className='mb-1 text-nowrap col-lg-3'>Last Name *</Form.Label>
                        <Form.Control
                          type="text"
                          aria-describedby="passwordHelpBlock"
                          placeholder='Enter Last Name'
                          autoComplete="off"
                          {...register("lastName", { required: "Please enter last name." })}
                        />
                        <ErrorMessage name="lastName" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />
                      </Col>
                    </Row>
                    <Row>
                      <Col className='text-center mb-4 d-flex align-items-center gap-3'>
                        <Form.Label htmlFor="txtMobileNumber" className='mb-1 text-nowrap col-lg-3'>Phone Number *</Form.Label>
                        <div className='w-100'>
                          <TelInput useFormMethods={
                            {
                              register,
                              control,
                              trigger
                            }
                          } name="mobileNumber" required={true} schema={{
                            errorMessage: {
                              required: "Please enter phone number",
                              // validate: 'Please enter a valid phone number.'
                            }
                          }} ></TelInput>
                        </div>
                        <ErrorMessage name="mobileNumber" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />
                      </Col>
                    </Row>
                  </Col>
                </Row> */}

                      <div className='row'>
                        <div className='col-lg-12 mb-3'>
                          <Form.Label htmlFor="ddConsentLanguage" className='mb-1'>Consent Language</Form.Label>
                          <div className='consent-language-box' dangerouslySetInnerHTML={{ __html: makeLinksClickable(consentLanguageMessage) }}
                          >
                          </div>
                        </div>

                        <div className='col-lg-6 mt-3'>
                          <button type="submit" disabled={!companyActive} className='mainbutton btn px-4' >I Agree</button>
                        </div>
                      </div>
                    </div>
                  </form>
                  {/* <Image
                    src="/img/instantconnenct.png"
                    width={120}
                    height={50}
                    alt="logo"
                    className="img-fluid mt-3"
                  /> */}
                </div>
              </div>

              <Modal backdrop="static"
                keyboard={false} onHide={handleCloseErrorModal} show={showErrorModal} >
                <Modal.Header closeButton>
                  <Modal.Title> <h5>Alert</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className='col-lg-12'>
                    <h5>{errorMessage}</h5>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button className='mainbutton btn px-4 mb-2' type='button' onClick={handleCloseErrorModal}>Close</button>
                </Modal.Footer>
              </Modal>
              <Modal backdrop="static"
                keyboard={false} show={showSuccessModal} >
                <Modal.Header >
                  <Modal.Title> <h5>Confirmation</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className='col-lg-12'>
                    <h5>{errorMessage}</h5>
                  </div>
                </Modal.Body>
              </Modal>
            </>
        }

      </>
      : null
  )
}

export default ConsentForm
